export var EvaluationLevel;
(function (EvaluationLevel) {
    EvaluationLevel["STRONG"] = "strong";
    EvaluationLevel["MEDIUM"] = "medium";
    EvaluationLevel["WEAK"] = "weak";
    EvaluationLevel["TOO_SHORT"] = "tooshort";
    EvaluationLevel["TOO_LONG"] = "toolong";
    EvaluationLevel["INVALID"] = "invalid";
})(EvaluationLevel || (EvaluationLevel = {}));
export var DEFAULT_MIN_LENGTH = 6;
export var DEFAULT_MAX_LENGTH = 15;
export var evaluationLevels = {
    strong: {
        breakpoint: 9,
    },
    medium: {
        breakpoint: 7,
    },
    weak: {
        breakpoint: 1,
    },
    tooshort: {
        breakpoint: 0,
    },
    toolong: {
        breakpoint: -1,
    },
    invalid: {
        breakpoint: 0,
    },
};
/**
 * Evaluate the length of the password, the higher the length the higher the score
 * @param password is the password to be validated
 * @returns {number} equals a calculated score depending on the password length
 */
export var evaluatePasswordLength = function (password) {
    var calculatedPasswordLengthScore = 0;
    if (password.length < 6) {
        return 0;
    }
    if (password.length > 15) {
        return -1;
    }
    if (password.length >= 6) {
        calculatedPasswordLengthScore += 1;
    }
    if (password.length >= 9) {
        calculatedPasswordLengthScore += 2;
    }
    if (password.length >= 12) {
        calculatedPasswordLengthScore += 1;
    }
    return calculatedPasswordLengthScore;
};
/**
 * Evaluate the usage of uppercase letters
 * @param password is the password to be validated
 * @returns {number} equals a calculated score depending on the usage of uppercase letters
 */
export var evaluateUpperCaseUsage = function (password) {
    var calculatedPasswordUppercaseScore = 0;
    if (password.toLowerCase() !== password) {
        calculatedPasswordUppercaseScore += 1;
    }
    return calculatedPasswordUppercaseScore;
};
/**
 * Evaluate the usage of lowercase letters
 * @param password is the password to be validated
 * @returns {number} equals a calculated score depending on the usage of lowercase letters
 */
export var evaluateLowerCaseUsage = function (password) {
    var calculatedPasswordLowerCaseScore = 0;
    if (password.toUpperCase() !== password) {
        calculatedPasswordLowerCaseScore += 1;
    }
    return calculatedPasswordLowerCaseScore;
};
/**
 * Evaluate the usage of digits
 * @param password is the password to be validated
 * @returns {number} equals a calculated score depending on the usage of digits
 */
export var evaluateDigitsUsage = function (password) {
    var calculatedPasswordDigitScore = 0;
    // Check for general usage of digits
    if (/\d/.test(password)) {
        calculatedPasswordDigitScore += 1;
    }
    // Check for usage of digits in the middle of the string
    if (/.+\d.+/.test(password)) {
        calculatedPasswordDigitScore += 1;
    }
    return calculatedPasswordDigitScore;
};
/**
 * Evaluate the usage of symbols
 * @param password is the password to be validated
 * @returns {number} equals a calculated score depending on the usage of symbols
 */
export var evaluateSymbolsUsage = function (password) {
    var calculatedPasswordSymbolScore = 0;
    // Check for general usage of symbols
    if (/([^\d\w\s]|_)/.test(password)) {
        calculatedPasswordSymbolScore += 1;
    }
    // Check for usage of symbols in the middle of the string
    if (/.+([^\d\w\s]|_).+/.test(password)) {
        calculatedPasswordSymbolScore += 1;
    }
    return calculatedPasswordSymbolScore;
};
export var defaultEvaluationPipeline = [
    evaluatePasswordLength,
    evaluateUpperCaseUsage,
    evaluateLowerCaseUsage,
    evaluateDigitsUsage,
    evaluateSymbolsUsage,
];
/**
 * Evaluate a password on the basis of a scoring system dependent on different checks
 * @param password is the password to be validated
 * @param minLength is the minimum length of the password
 * @param maxLength is the maximum length of the password. Set this to -1 to disable
 * @returns {number} equals a calculated score depending on the different checks, ranges from 0 (invalid) to 10
 */
export var evaluatePassword = function (password, minLength, maxLength, pipeline) {
    if (minLength === void 0) { minLength = DEFAULT_MIN_LENGTH; }
    if (maxLength === void 0) { maxLength = DEFAULT_MAX_LENGTH; }
    if (pipeline === void 0) { pipeline = defaultEvaluationPipeline; }
    if (password.length < minLength) {
        return 0;
    }
    if (maxLength > -1 && password.length > maxLength) {
        return -1;
    }
    var calculatedPasswordScore = pipeline.reduce(function (score, step) { return (score += step(password)); }, 0);
    return calculatedPasswordScore;
};
/**
 * Transforms the password score into one of the indication levels
 * @param passwordScore is the current score of the password as number
 * @param config the level config for the breakpoints
 * @returns the evaluation result
 */
export var getEvaluationLevelFromScore = function (passwordScore, config) {
    if (config === void 0) { config = evaluationLevels; }
    if (passwordScore >= config.strong.breakpoint) {
        return EvaluationLevel.STRONG;
    }
    if (passwordScore >= config.medium.breakpoint) {
        return EvaluationLevel.MEDIUM;
    }
    if (passwordScore >= config.weak.breakpoint) {
        return EvaluationLevel.WEAK;
    }
    if (passwordScore === 0) {
        return EvaluationLevel.TOO_SHORT;
    }
    if (passwordScore === -1) {
        return EvaluationLevel.TOO_LONG;
    }
    return EvaluationLevel.INVALID;
};
export var getEvaluationLevelFromPassword = function (password, minLength, maxLength, config, pipeline) {
    if (minLength === void 0) { minLength = DEFAULT_MIN_LENGTH; }
    if (maxLength === void 0) { maxLength = DEFAULT_MAX_LENGTH; }
    if (config === void 0) { config = evaluationLevels; }
    if (pipeline === void 0) { pipeline = defaultEvaluationPipeline; }
    var score = evaluatePassword(password, minLength, maxLength, pipeline);
    return getEvaluationLevelFromScore(score, config);
};
//# sourceMappingURL=index.js.map